import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';
import { EllipsisVerticalIcon, PencilIcon, Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RowMenuProps {
  onEdit: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
}

export const RowMenu = ({ onEdit, onDelete, deleteDisabled }: RowMenuProps) => {
  const { t } = useTranslation('admin');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={t('admin.rowMenu.rowActions')}
        >
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onEdit}>
          <PencilIcon />
          {t('admin.rowMenu.edit')}
        </DropdownMenuItem>
        <DropdownMenuItem disabled={deleteDisabled} variant="destructive" onSelect={onDelete}>
          <Trash2Icon />
          {t('admin.rowMenu.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
